import { jsx as _jsx } from "react/jsx-runtime";
import { ShoppingCart, Pause, Receipt, FileText, CalendarClock, SlidersHorizontal, LayoutDashboard, ShieldAlert, CalendarDays, Wallet, Package, FolderTree, Percent, Users, Truck, Boxes, PackagePlus, ArrowLeftRight, ClipboardList, UserCog, Store, BarChart3, Settings, ScrollText, 
// common UI glyphs
Search, X, Check, CheckCircle2, Info, Plus, Minus, Trash2, ArrowRight, ArrowLeft, ChevronDown, ChevronUp, ChevronRight, Printer, ScanLine, Wifi, WifiOff, Battery, Sun, Moon, LogOut, User, CircleAlert, Loader2, 
// app-update / notifications glyphs (Phase 7-Follow confirm-update flow)
Download, RotateCw, Bell, BellOff, 
// tender / POS
Banknote, QrCode, CreditCard, Clock, Split, 
// editing / quotations
Pencil, 
// sync / queue tooling
RefreshCw, Database, 
// sidebar collapse toggle
Menu, PanelLeftClose, 
// product image picker
Image as ImageIcon, 
// bulk import / grid
Upload, Table, } from "lucide-react";
import { clsx } from "clsx";
// Named allowlist — keeps the bundle tree-shaken. Add here when a page needs a new glyph.
const ICONS = {
    "shopping-cart": ShoppingCart,
    "pause": Pause,
    "receipt": Receipt,
    "file-text": FileText,
    "calendar-clock": CalendarClock,
    "sliders-horizontal": SlidersHorizontal,
    "layout-dashboard": LayoutDashboard,
    "shield-alert": ShieldAlert,
    "calendar-days": CalendarDays,
    "wallet": Wallet,
    "package": Package,
    "folder-tree": FolderTree,
    "percent": Percent,
    "users": Users,
    "truck": Truck,
    "boxes": Boxes,
    "package-plus": PackagePlus,
    "arrow-left-right": ArrowLeftRight,
    "clipboard-list": ClipboardList,
    "user-cog": UserCog,
    "store": Store,
    "bar-chart-3": BarChart3,
    "settings": Settings,
    "scroll-text": ScrollText,
    "search": Search,
    "x": X,
    "check": Check,
    "check-circle": CheckCircle2,
    "info": Info,
    "plus": Plus,
    "minus": Minus,
    "trash-2": Trash2,
    "arrow-right": ArrowRight,
    "arrow-left": ArrowLeft,
    "chevron-down": ChevronDown,
    "chevron-up": ChevronUp,
    "chevron-right": ChevronRight,
    "printer": Printer,
    "scan-line": ScanLine,
    "wifi": Wifi,
    "wifi-off": WifiOff,
    "battery": Battery,
    "sun": Sun,
    "moon": Moon,
    "log-out": LogOut,
    "user": User,
    "circle-alert": CircleAlert,
    "loader-2": Loader2,
    "banknote": Banknote,
    "qr-code": QrCode,
    "credit-card": CreditCard,
    "clock": Clock,
    "split": Split,
    "edit": Pencil,
    "trash": Trash2,
    "refresh-cw": RefreshCw,
    "database": Database,
    "menu": Menu,
    "panel-left-close": PanelLeftClose,
    "image": ImageIcon,
    "download": Download,
    "rotate-cw": RotateCw,
    "bell": Bell,
    "bell-off": BellOff,
    "upload": Upload,
    "table": Table,
};
const SIZE_PX = { sm: 13, md: 16, lg: 20 };
export function Icon({ name, size = "md", className, ...rest }) {
    const Component = ICONS[name];
    return (_jsx(Component, { "aria-hidden": "true", size: SIZE_PX[size], className: clsx("lucide", size === "sm" && "lucide-sm", size === "lg" && "lucide-lg", className), ...rest }));
}
//# sourceMappingURL=Icon.js.map